<template>
	<div class="violation">
		<header-bar :headerData="headerData"></header-bar>
		<div class="photograph">
			{{photograph.region | addOneSpace}}
		</div>
		<div class="photograph-tag-warp" v-if="photograph.violationList.length != 0">
			<div class="clearfix photograph-tag">
				<div class="photograph-tagItem">
					<p v-text="photograph.violationList.length"></p>
					<p>违章</p>
				</div>
				<div class="photograph-tagItem">
					<p v-text="violationTotal.fine"></p>
					<p>罚款</p>
				</div>
				<div class="photograph-tagItem">
					<p v-text="violationTotal.deduction"></p>
					<p>扣分</p>
				</div>
			</div>
		</div>
		<div class="both" v-if="photograph.violationList.length != 0"></div>
		<div class="photograph-con">
			<img v-if="photograph.violationList.length == 0" class="nomessage" :src="commmonWebConfig.webCommonUtils + '/img/mapply/violation/nomessage.png'" />
			<p v-if="photograph.violationList.length == 0" class="nomessage-text">尚无新违章记录</p>
			<ul class="violationList">
				<li v-for="(item,index) in photograph.violationList">
					<div class="violationList-title" v-text="item.area"></div>
					<div class="violationList-des" v-text="item.act"></div>
					<div class="violationList-pp"><span>罚款:<em v-text="item.money"></em></span><span>扣分:<em v-text="item.fen"></em></span><span v-text="item.date"></span></div>
				</li>
			</ul>
		</div>
	</div>
</template>
<style scoped lang="less">
	
</style>
<script>
	import { Toast } from 'mint-ui';
	import { MessageBox } from 'mint-ui';
	import HeaderBar from '@/components/violation/header';
	export default {
		name: 'violationIndex',
		data:function() {
			return {
				headerData:{
					headerTxt: '违章信息', 			//title名称
					isBackShow: true,						//返回按钮 true-->显示
					isEditShow: true,						//编辑按钮 true-->显示
					isSaveShow: false,					//保存按钮 true-->显示
				},
				photograph:{
					region:"",
					violationList:[]
				}
			}
		},
		beforeCreate: function() {
			getCommonJsIns.initSingleCSSNEW({
				cssURL: "/css/mapply/violation/result.css"
			});
		},
		mounted: function() {
			var self = this;
//			getCommonJsIns.initCSSNEW();
			getCommonJsIns.initSingleCSSNEW({
				cssURL: "/css/mapply/violation/result.css"
			});
			//确保重要依赖的js加载完成
			getCommonJsIns.initJSNEW(this.webReady);	
		},
		computed:{
			violationTotal:function(){
				var fine = 0;
				var deduction = 0;

				for(var i in this.photograph.violationList){
					fine += parseInt(this.photograph.violationList[i].money,10);
					deduction += parseInt(this.photograph.violationList[i].fen,10);
				}
				return {
					fine:fine,
					deduction:deduction
				};

			}
		},
		methods: {
			webReady: function() {	
				var violationData = JSON.parse(localStorage.getItem('violationData'));
				if(violationData!=''&&violationData!=null){
					this.photograph.violationList = violationData.value;
					this.photograph.region = violationData.licencePlate;
				}
			}
		},
		components:{
			HeaderBar
		},
		filters:{
			addOneSpace: function (value) {
		    if (!value) return ''
		    return value.replace(/([\u4e00-\u9fa5][A-Z])/g,'$1 ')
		  }
		}
	}
</script>


// WEBPACK FOOTER //
// src/views/violation/checkResult.vue